import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, FunzioniModelli, IFunzioniModelliLng } from '../../models/-index';

import { CrudGenericsService } from '../common/crud-generics';

import { Observable } from 'rxjs';

@Injectable()
export class FunzioniModelliService extends CrudGenericsService<FunzioniModelli, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FunzioniModelli`);
    this.base = `${env.apiUrl}/api/FunzioniModelli/`;
  }

  //  auth component
  GetAll_FunzioniModelliLng_ByGruppo(id: number): Observable<IFunzioniModelliLng[]> {
    const u = this.base + 'GetAll_FunzioniModelliLng_ByGruppo/' + id;
    return this.http.get<IFunzioniModelliLng[]>(`${u}`);
  }
  ClickAccessModifyFM(id: number, campo: string) {
    const u = this.base + 'ClickAccessModifyFM?id=' + id + '&campo=' + campo;
    return this.http.post(`${u}`, null);
  }
}
